import React, { useEffect, useState } from "react";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import BlogAside from "../blog/blog-aside/BlogAside";
import BlogCommentForm from "./blog-comment-form/BlogCommentForm";
import BlogUsersComment from "./blog-users-comment/BlogUsersComment";
import { Helmet } from "react-helmet";
import { useGetBlogDetailsQuery } from "../products/productSlice";
import { useParams } from "react-router-dom";
import axios from "axios";
import { base_url } from "../../server";
import { useTranslation } from "react-i18next";
import blog1 from "../../assets/img/blog/WA0045.jpg";
import blog2 from "../../assets/img/blog/WA0046.jpg";
import blog3 from "../../assets/img/blog/WA0047.jpg";
import blog4 from "../../assets/img/blog/WA0048.jpg";


const cosmeticBlogCategories = [
  {
    id: 1,
    url: blog1,
    name: "Transform Your Outdoor Space: Expert Landscaping Tips & Ideas",
    description: "Your outdoor space is the first impression your home makes—so why not make it unforgettable? Landscaping isn’t just about planting a few flowers or mowing the lawn. It's about creating a cohesive, beautiful environment that enhances the look and feel of your property. Whether you're working with a sprawling backyard or a compact front garden, the right landscaping can completely transform your space."
  },
  {
    id: 2,
    url: blog2,
    name: "Landscaping Inspiration for Every Season",
    description: "Start by defining how you want to use your outdoor area. Do you envision a relaxing patio, a vibrant flower garden, or a space for entertaining guests? Planning with purpose helps guide your design choices, from selecting the right plants to choosing the best hardscape elements like walkways, decks, or retaining walls. Think of your yard as an extension of your home—it should reflect your personality and lifestyle."
  },
  {
    id: 3,    
    url: blog3,
    name: "Simple Landscaping Upgrades That Wow",
    description: "One of the most impactful ways to upgrade your landscaping is through layering and texture. Use a variety of plants—trees, shrubs, perennials, and ground covers—to create depth and visual interest. Incorporate stone, wood, or gravel elements for contrast, and don’t forget lighting! Well-placed outdoor lighting not only adds ambiance but also improves safety and functionality after dark."
  },
  {
    id: 4,
    url: blog4,
    name: "The Ultimate Guide to Modern Landscaping Design",
    description: "Finally, maintenance is key to long-term success. Choose plants suited to your climate and soil to reduce upkeep. Invest in a simple irrigation system to keep things green without extra effort. And remember: great landscaping doesn’t have to happen all at once. Start with small changes, and let your outdoor space evolve with your vision and budget."
  },
  
];
function BlogDetail() {
  const params = useParams();

  const [data, setData] = useState(null);
  const [isLoading, setisLoading] = useState(false);

  const token = window.localStorage.getItem("token");
  const baseUrl = base_url();
  const getData = async () => {
    setisLoading(true);
    try {
      const res = await axios.get(`${baseUrl}blogs/${params.id}`, {
        withCredentials: true,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      });
      setisLoading(false);
      setData(res.data);
    } catch (error) {
      setisLoading(false);
      console.log("Fail to Load Blog Detail !");
    }
  };

  useEffect(() => {
    getData();
  }, []);
  const { t } = useTranslation();
  const [blogData, setBlogData] = useState(cosmeticBlogCategories);
  const filterData = blogData.find((item) => {

    return item.id == params.id;
  });

  console.log("filterData", filterData);

  return (
    <>
      <Helmet>
        <title>Blog Detail | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title="Blog Detail" t={t} />
      <section className="blogDetailSec sectionPD">
        <div className="container">
          {isLoading && (
            <div className="preloaderCount">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-8">
              <div className="blogDetailInfo">
                <div className="blogDetailContent">
                  <figure className="currentBlogImg">
                    <img
                      src={filterData?.url}
                      alt="Blog"
                      className="img-fluid"
                    />
                  </figure>
                  <h4>{filterData.name}</h4>
                  <p>{filterData.description}</p>
                </div>
                {/* <BlogUsersComment data={data} /> */}
                <BlogCommentForm />
              </div>
            </div>
            <div className="col-md-4">
              <BlogAside t={t} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
